import { render, staticRenderFns } from "./SetPassword.vue?vue&type=template&id=290ef5e4&scoped=true"
import script from "./SetPassword.vue?vue&type=script&lang=js"
export * from "./SetPassword.vue?vue&type=script&lang=js"
import style0 from "./SetPassword.vue?vue&type=style&index=0&id=290ef5e4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "290ef5e4",
  null
  
)

export default component.exports